import axios, { AxiosError } from 'axios';

export const isNetworkError = (error: unknown): boolean =>
  axios.isAxiosError(error) && error.code === AxiosError.ERR_NETWORK;
